import { create } from 'zustand';

// Shopify App Bridge v4 intercepts window.history.back/forward() and escalates
// them to the parent Admin frame, causing a full page reload. We maintain our
// own navigation stack so useNavigateBack/useNavigateForward can use
// router.replace() instead.

type NavigationHistoryState = {
  stack: string[];
  index: number;
};

type NavigationHistoryActions = {
  push: (pathname: string) => void;
  back: () => string | null;
  forward: () => string | null;
};

type NavigationHistoryStore = NavigationHistoryState & NavigationHistoryActions;

export const useNavigationHistoryStore = create<NavigationHistoryStore>()((set, get) => ({
  back: () => {
    const { stack, index } = get();

    if (index <= 0) {
      return null;
    }
    const next = index - 1;
    set({ index: next });
    return stack[next];
  },

  forward: () => {
    const { stack, index } = get();

    if (index >= stack.length - 1) {
      return null;
    }
    const next = index + 1;
    set({ index: next });
    return stack[next];
  },
  index: -1,

  push: (pathname) =>
    set((s) => {
      // If pathname matches the current position, it's a back/forward navigation — skip
      if (s.stack[s.index] === pathname) {
        return s;
      }
      const stack = [...s.stack.slice(0, s.index + 1), pathname];

      return { index: stack.length - 1, stack };
    }),
  stack: [],
}));
